import type { AnalyticsSearchStatsParams, AnalyticsSearchStatsRequestParams } from '~/services/AnalyticsService';

export const analyticsQueryKeys = {
  all: ['analytics'] as const,
  stats: (params: AnalyticsSearchStatsRequestParams) => [...analyticsQueryKeys.all, 'stats', params] as const,
  statsIdle: () => [...analyticsQueryKeys.all, 'stats', 'idle'] as const,
  counts: (params: AnalyticsSearchStatsParams) => [...analyticsQueryKeys.all, 'counts', params] as const,
  countsIdle: () => [...analyticsQueryKeys.all, 'counts', 'idle'] as const,
};
